import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import AptosNormal from "../../../utils/Customfonts/Aptos.ttf";
import AptosBold from "../../../utils/Customfonts/Aptos-Bold.ttf";
import DejaVuSans from "../../../utils/Customfonts/DejaVuMathTeXGyre.ttf";
import NABLHeader from "../../image/Nabl_Header.png";
import NONABLHeader from "../../image/NON_NABL_header.png";
import IAS from "../../image/NON_NABL_header.png";
import Footer from "../../image/footer.png";
import autoTable from "jspdf-autotable";
import { parseDepth, parseRange } from "../../../utils/commonComponent/parse";
import { DispatchModeOptions } from "../../disciplineMaster/disiplineConst";
import { InwardPDfColumn } from "../../../global";

const customFontFamily = {
  bold: "bold",
  normal: "normal",
  boldFont: "AptosBold",
  normalFont: "AptosNormal",
};

let config = {
  margin: 15,
  leftMarginOffset: 0,
  borderMagin: 8,
  headerImgHeight: 80,
  headerTableHeight: 25,
  headerTitleHeight: 25,
  footerImgHeight: 70,
  footerTableHeight: 50,
  fontSize: 11,
  cusotmerHeight: 50,
  bordergap: 5,
  currentY: 0,
  get footerTotalHeight() {
    return this.footerImgHeight + this.footerTableHeight;
  },
  get topY() {
    return (
      this.headerTableHeight +
      this.headerTitleHeight +
      this.borderMagin +
      this.headerImgHeight
    );
  },
};

// 🔹 Helper function to draw header + footer
function addHeaderFooter(doc, inputStates) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const headers = {
    1: NABLHeader,
    2: NONABLHeader,
    3: IAS,
  };
  const headerImage = headers[inputStates?.inputStates] || NONABLHeader;
  doc.addImage(headerImage, "PNG", config.leftMarginOffset, 0, pageWidth - config.leftMarginOffset, config?.headerImgHeight);
  doc.addImage(
    Footer,
    "PNG",
    config.leftMarginOffset,
    pageHeight - config?.footerImgHeight,
    pageWidth - config.leftMarginOffset,
    config?.footerImgHeight
  );
}

function drawInwardTable(doc, jobDetails, inputStates) {
  let tableBody = [
    [
      {
        content: "Customer Details",
        colSpan: 2,
        styles: { font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold },
      },
      { content: "Other Details", colSpan: 2, styles: { font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold } },
    ],
    [
      { content: "Name of Customer:",  },
      { content: inputStates?.customerName || "" },
      { content: "Report Dispatch Mode:",  },
      { content: DispatchModeOptions.find(option => option.id == inputStates?.dispatchMode)?.label || ""},
    ],
    [
      {
        content: "Office Add, Email ID and Phone/Fax:",
      },
      { content: inputStates?.address || "" },
      { content: "GSTIN:",  },
      { content: jobDetails?.gstNumber || "" },
    ],
    [
      { content: "Name of Principal Client:",  },
      { content: inputStates?.principleClient || "" },
      { content: "PAN:",  },
      { content: jobDetails?.panNo || "" },
    ],
    [
      { content: "Contact Person:",  },
      { content: inputStates?.contactPerson || "", colSpan: 3 },
    ],
    [{ content: "Sample Details", colSpan: 4, styles: { font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold } }],
    [
      {
        content: `Name of Work: ${jobDetails?.projectName || ""}`,
        colSpan: 2,
      },
      {
        content: `Lab Ref No.: ${inputStates?.labReferenceNo || ""}`,
        colSpan: 2,
      },
    ],
  ];
  const totalPageWidth = doc.internal.pageSize.getWidth() - config.leftMarginOffset - config.margin * 2;
  const columnPercentages = [25, 25, 25, 25];
  const columnWidths = columnPercentages.map((percentage) => {
    return (totalPageWidth * percentage) / 100;
  });

  autoTable(doc, {
    startY: config.topY + 5,
    body: tableBody,
    theme: "grid",
    styles: {
      cellPadding: { top: 5, left: 5, bottom: 5, right: 5 },
      fontSize: config.fontSize,
      halign: "left",
      valign: "middle",
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      font: customFontFamily?.normalFont,
      fontStyle: customFontFamily?.normal,
    },
    margin: { left: config.leftMarginOffset + config.margin, right: config.margin },
    didParseCell: function (data) {
      const boldTitles = ["Job No.:", "Date:", "Name of Work:", "Lab Ref No.:"];
      const cellContent = data.cell.raw?.content?.trim();
      if (boldTitles.includes(cellContent)) {
        data.cell.styles.fontStyle = "bold";
      }
    },
    columnStyles: {
      0: { cellWidth: columnWidths[0] },
      1: { cellWidth: columnWidths[1] },
      2: { cellWidth: columnWidths[2] },
      3: { cellWidth: columnWidths[3] },
    },
  });

  return doc.lastAutoTable.finalY;
}
// Updated function to handle multiple test IDs with proper grouping and rowSpan
function prepareGroupedTestsData(testRows) {
  // First, expand rows with multiple test IDs
  const expandedRows = [];
  
  testRows.forEach((row) => {
    // Check if testId contains multiple IDs (comma-separated)
    const testIds = row.testId ? String(row.testId).split(',').map(id => id.trim()) : [''];
    
    testIds.forEach((testId) => {
      const testDetail = row.testDetails?.[testId];
      // Resolve this specific test's material name using testDetail.materialId
      const testMaterialId = testDetail?.materialId
        ? String(testDetail.materialId)
        : null;

      const testMaterialName = testMaterialId && row.materialNamesMap
        ? row.materialNamesMap[testMaterialId] ?? row.materialName ?? ""
        : row.materialName ?? "";

      expandedRows.push({
        ...row,
        testId: testId,
        testName: testDetail?.testName || row.testName || '',
        testMethod: testDetail?.testMethod || row.testMethod || '',
        // Each expanded row gets its own specific material name
        resolvedMaterialName: testMaterialName,
      });
    });
  });

  // Group by sample details (everything except test-specific info)
  const grouped = [];
  const map = {};
  
  expandedRows.forEach((test) => {
    // Create a unique key for grouping based on sample details
    const sampleKey = `${test.locationChainageNo}_${test.boreHoleNo}_${test.fromDepth}_${test.toDepth}_${test.sampleType}_${test.quantity}_${test.lengthOfRock}_${test.materialName}`;
    
    if (!map[sampleKey]) {
      map[sampleKey] = [];
    }
    map[sampleKey].push(test);
  });

  // Flatten the grouped data with rowSpan information
  Object.values(map).forEach((group) => {
    group.forEach((test, idx) => {
      grouped.push({
        ...test,
        _rowSpan: group.length,
        _isFirst: idx === 0, // Only show sample details for the first row of the group
      });
    });
  });

  return grouped;
}

function drawGroupedTestsTable(doc, testRows, currentY) {
  const uniqueTestIdCount = testRows.reduce((acc, row) => {
    if (row.testId) {
      row.testId.split(',').forEach(id => acc.add(id.trim()));
    }
    return acc;
  }, new Set()).size;

  if (uniqueTestIdCount >= InwardPDfColumn) {
    const head = [
      [
        "Sr.No.",
        "Location/Chainage No./Source.",
        "Sample ID / BH No. / Trial Pit No.",
        "Depth",
        "Sample Type",
        "Qty",
        "Length Of Rock",
        "Type of Sample",
        "Tests",
        "Ref standards",
      ],
    ];

    // Use the new grouping function
    const groupedTests = prepareGroupedTestsData(testRows);
    let body = [];
    let sampleGroupCounter = 0;

    // Build the table body with proper rowSpan handling
    groupedTests.forEach((test) => {
      let row = [];
      // Sample details columns with rowSpan - only add for first row of each group
      if (test._isFirst) {
        sampleGroupCounter++;

        row = [
          // Sr. No. with rowSpan
          {
            content: sampleGroupCounter.toString(),
            rowSpan: test._rowSpan,
            styles: { valign: "middle", halign: "center" },
          },
          // Location / Change No. with rowSpan
          {
            content: test?.locationChainageNo || "",
            rowSpan: test._rowSpan,
            styles: { valign: "middle", halign: "center" },
          },
          // Sample ID / BH No. with rowSpan
          {
            content: test?.boreHoleNo || "",
            rowSpan: test._rowSpan,
            styles: { valign: "middle", halign: "center" },
          },
          // Depth with rowSpan
          {
            content: parseDepth(test?.fromDepth, test?.toDepth) || "",
            rowSpan: test._rowSpan,
            styles: { valign: "middle", halign: "center" },
          },
          // Sample Type with rowSpan
          {
            content: test?.sampleType?.replaceAll("||", ", ") || "",
            rowSpan: test._rowSpan,
            styles: { valign: "middle", halign: "center" },
          },
          // Qty with rowSpan
          {
            content: test?.quantity || "",
            rowSpan: test._rowSpan,
            styles: { valign: "middle", halign: "center" },
          },
          // Length Of Rock with rowSpan
          {
            content: parseDepth(test?.lengthOfRock) || "",
            rowSpan: test._rowSpan,
            styles: { valign: "middle", halign: "center" },
          },
          // Type of Sample (Material Name) with rowSpan
          {
            content: test?.materialName || "",
            rowSpan: test._rowSpan,
            styles: { valign: "middle", halign: "center" },
          },
        ];
      } else {
        // For subsequent rows in the group, don't add the sample detail columns
        row = [];
      }
      // Test-specific columns - add for every row
      row.push(test?.testName || "", test?.testMethod || "");

      body.push(row);
    });

    autoTable(doc, {
      head: head,
      body: body,
      startY: currentY + 5,
      theme: "grid",
      styles: {
        cellPadding: { top: 3, left: 2, bottom: 3, right: 2 },
        fontSize: config.fontSize - 3,
        halign: "center",
        valign: "middle",
        textColor: 0,
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
        font: customFontFamily?.normalFont,
        fontStyle: customFontFamily?.normal,
      },
      headStyles: {
        fillColor: false,
        font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold,
        halign: "center",
        valign: "middle",
      },
      margin: {
        top: config.topY + 5,
        left: config.leftMarginOffset + config.margin,
        right: config.margin,
        bottom: config.footerTotalHeight + config.borderMagin,
      },
    });

  } else {
    // 1. Expand rows with per-test resolvedMaterialName
    const expandedRows = [];

    testRows.forEach((row) => {
      const testIds = row.testId ? String(row.testId).split(',').map(id => id.trim()) : [''];

      testIds.forEach((testId) => {
        const testDetail = row.testDetails?.[testId];
        // Resolve this specific test's material name using testDetail.materialId
        const testMaterialId = testDetail?.materialId
          ? String(testDetail.materialId)
          : null;

        const resolvedMaterialName = testMaterialId && row.materialNamesMap
          ? row.materialNamesMap[testMaterialId] ?? row.materialName ?? ""
          : row.materialName ?? "";

        expandedRows.push({
          ...row,
          testId: testId,
          testName: testDetail?.testName || row.testName || '',
          testMethod: testDetail?.testMethod || row.testMethod || '',
          // Per-test resolved material name
          resolvedMaterialName: resolvedMaterialName,
        });
      });
    });

    // 2. Build material structure using resolvedMaterialName
    const materialsMap = {};
    const materialOrder = [];
    const groups = {};

    expandedRows.forEach((entry) => {
      // Use resolvedMaterialName instead of materialName
      const mat = entry.resolvedMaterialName || entry.materialName || "Type of sample";
      const testLabel = `${entry.testName || ""}${entry.testMethod ? ` (${entry.testMethod})` : ""}`.trim();

      if (!materialsMap[mat]) {
        materialsMap[mat] = [];
        materialOrder.push(mat);
      }
      if (testLabel && !materialsMap[mat].includes(testLabel)) {
        materialsMap[mat].push(testLabel);
      }

      const sampleKey = `${entry.locationChainageNo || ""}||${entry.boreHoleNo || ""}||${entry.fromDepth || ""}||${entry.toDepth || ""}||${entry.sampleType || ""}||${entry.quantity || ""}||${entry.lengthOfRock || ""}`;
      if (!groups[sampleKey]) groups[sampleKey] = [];
      // Store resolvedMat on each entry for present mapping
      groups[sampleKey].push({ ...entry, _resolvedMat: mat });
    });

    const sampleGroups = Object.values(groups);

    // 3. Build table headers with material grouping
    const headerRow1 = [
      { content: "Sr.No.", rowSpan: 2, styles: { valign: "middle", halign: "center" } },
      { content: "Location/Chainage No./Source.", rowSpan: 2, styles: { valign: "middle", halign: "center" } },
      { content: "Sample ID / BH No. / Trial Pit No.", rowSpan: 2, styles: { valign: "middle", halign: "center" } },
      { content: "Depth", rowSpan: 2, styles: { valign: "middle", halign: "center" } },
      { content: "Sample Type", rowSpan: 2, styles: { valign: "middle", halign: "center" } },
      { content: "Qty", rowSpan: 2, styles: { valign: "middle", halign: "center" } },
      { content: "Length Of Rock", rowSpan: 2, styles: { valign: "middle", halign: "center" } },
    ];

    const headerRow2 = [];

    // Add material columns to header
    materialOrder.forEach((material) => {
      const tests = materialsMap[material] || [];
      const colspan = Math.max(1, tests.length);

      headerRow1.push({
        content: material,
        colSpan: colspan,
        styles: { halign: "center", valign: "middle", font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold }
      });

      // Add test sub-headers
      tests.forEach((testLabel) => {
        headerRow2.push({
          content: testLabel,
          styles: { halign: "center", valign: "middle" }
        });
      });
    });

    const head = [headerRow1, headerRow2];

    // 4. Build table body
    const body = [];

    sampleGroups.forEach((group, rowIndex) => {
      const first = group[0] || {};

      // Build present map using _resolvedMat (per-test specific material)
      const present = {};
      group.forEach((e) => {
        const mat = e._resolvedMat || e.materialName || "Type of sample";
        const label = `${e.testName || ""}${e.testMethod ? ` (${e.testMethod})` : ""}`.trim();
        if (!present[mat]) present[mat] = new Set();
        if (label) present[mat].add(label);
      });

      const row = [
        { content: (rowIndex + 1).toString(), styles: { halign: "center" } },
        { content: first.locationChainageNo || "", styles: { halign: "center" } },
        { content: first.boreHoleNo || "", styles: { halign: "center" } },
        { content: parseDepth(first.fromDepth, first.toDepth) || "", styles: { halign: "center" } },
        { content: first.sampleType?.replaceAll("||", ", ") || "", styles: { halign: "center" } },
        { content: first.quantity || "", styles: { halign: "center" } },
        { content: parseDepth(first.lengthOfRock) || "", styles: { halign: "center" } },
      ];

      // Add cells for each material/test column
      materialOrder.forEach((material) => {
        (materialsMap[material] || []).forEach((testLabel) => {
          const has = present[material] && present[material].has(testLabel);
          row.push({
            content: has ? "✓" : "-",
            styles: { halign: "center", font: "DejaVuSans" }
          });
        });
      });

      body.push(row);
    });

   let calfontSize = (materialOrder.reduce((sum, mat) => sum + (materialsMap[mat]?.length || 0), 0) > 15) ? config.fontSize - 3.5 : config.fontSize - 3;

    autoTable(doc, {
      head: head,
      body: body,
      startY: currentY + 5,
      theme: "grid",
      styles: {
        cellPadding: { top: 3, left: 2, bottom: 3, right: 2 },
        fontSize: calfontSize,
        halign: "center",
        valign: "middle",
        textColor: 0,
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
        font: customFontFamily?.normalFont,
        fontStyle: customFontFamily?.normal,
      },
      headStyles: {
        fillColor: false,
        font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold,
        halign: "center",
        valign: "middle",
      },
      margin: {
        top: config.topY + 5,
        left: config.leftMarginOffset + config.margin,
        right: config.margin,
        bottom: config.footerTotalHeight + config.borderMagin,
      },
      //  Step 1: Clear the cell text so autotable doesn't draw it
      didParseCell: function (data) {
        const content = data.cell.raw?.content;
        if (content === "✓" || content === "-") {
          data.cell.text = []; // prevent autotable from rendering text
        }
      },
      //  Step 2: Draw it manually with correct font
      didDrawCell: function (data) {
        const content = data.cell.raw?.content;
        if (content === "✓" || content === "-") {
          const x = data.cell.x + data.cell.width / 2;
          const y = data.cell.y + data.cell.height / 2 + 4;

          doc.setFont("AptosBold", "bold");
          doc.setFontSize(14);
          // if (content === "✓") {
          //   // doc.setFont("DejaVuSans", "normal");
          // } else {
          //   // doc.setFont("AptosNormal", "normal");
          //   doc.setFontSize(15);
          // }
          doc.setTextColor(0);
          doc.text(content, x, y, { align: "center" });
          // Reset back
          doc.setFont("AptosNormal", "normal");
          doc.setFontSize(calfontSize);
        }
      },
    });
  }

  return doc.lastAutoTable.finalY;
}

const loadAndAddFont = async (
  pdfDoc,
  fontUrl,
  fontNameTTF,
  fontName,
  fontStyle
) => {
  const arrayBufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const chunkSize = 8192; // Process in chunks for large buffers
    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
    }
    return btoa(binary);
  };

  const fontResponse = await fetch(fontUrl);
  const fontBuffer = await fontResponse.arrayBuffer();
  const fontBase64 = arrayBufferToBase64(fontBuffer);

  pdfDoc.addFileToVFS(`${fontNameTTF}.ttf`, fontBase64);
  pdfDoc.addFont(`${fontNameTTF}.ttf`, fontName, fontStyle);
};

function drawOfficeUseTable(doc, officeFormData, currentY, userList, electronicSign, signImg, inputStates) {
  const pageHeight = doc.internal.pageSize.getHeight();
  const availableBottom = pageHeight - config.footerTotalHeight - config.borderMagin;
  const totalPageWidth = doc.internal.pageSize.getWidth() - config.leftMarginOffset - config.margin * 2;
  const colWidths = [35, 15, 25, 25].map((p) => (totalPageWidth * p) / 100);
  const sharedColumnStyles = {
    0: { cellWidth: colWidths[0] },
    1: { cellWidth: colWidths[1] },
    2: { cellWidth: colWidths[2] },
    3: { cellWidth: colWidths[3] },
  };

  // Fixed dimensions for signature images
  const SIGNATURE_CONFIG = {
    imgWidth: 60,
    imgHeight: 40,
    textSpacing: 10,
    labelSpacing: 10,
  };

  // Calculate minimum height for signature cells
  const minSignatureHeight = SIGNATURE_CONFIG.imgHeight + SIGNATURE_CONFIG.textSpacing + SIGNATURE_CONFIG.labelSpacing + 5;

  // Common function to draw signature
  const drawSignature = (user, cellX, cellY, cellWidth, label) => {
    const cellCenterX = cellX + cellWidth / 2;
    let contentY = cellY + 5;

    // Draw signature image if available
    if (user?.usersign && signImg) {
      try {
        doc.addImage(
          user.usersign,
          'PNG',
          cellCenterX - SIGNATURE_CONFIG.imgWidth / 2,
          contentY,
          SIGNATURE_CONFIG.imgWidth,
          SIGNATURE_CONFIG.imgHeight
        );
      } catch (error) {
        console.error(`Error adding ${label} signature image:`, error);
      }
    }
    contentY += SIGNATURE_CONFIG.imgHeight + SIGNATURE_CONFIG.textSpacing;
    // Build combined label text
    let finalLabel = label;

    if (electronicSign && user?.employeeName) {
      finalLabel = `${label} - ${user.employeeName}`;
    }
    // Draw combined label
    doc.setFontSize(config.fontSize);
    doc.setFont("AptosBold", "bold");
    doc.text(finalLabel, cellCenterX, contentY, { align: 'center' });
  };

  const part1Body = [
    [
      {
        content: "Note: Standard Retention period of test sample at our permanent facility is 30 days according to Quality Manual (Clause no 7.4.1)",
        colSpan: 4,
        styles: { halign: "left", font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold },
      }
    ],
    [
      { content: "Extra Retention Period Required" },
      {
        content: officeFormData?.retentionperiod || "",
        colSpan: officeFormData?.retentionFrequency ? 0 : 3,
        styles: { halign: "center" },
      },
      ...(officeFormData?.retentionFrequency
        ? [
            { content: "Extra Retention Required For:" },
            { content: officeFormData?.retentionFrequency || "", styles: { halign: "center" } },
          ]
        : []),
    ],
    [
      { content: "Statement of Conformity Required" },
      { content: officeFormData?.conformityStatement || "", styles: { halign: "center" } },
      {
        content: "Customer Signature with name",
        rowSpan: 2,
        colSpan: 2,
        styles: { halign: "center", valign: "bottom", fontSize: config.fontSize - 1, font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold, minCellHeight: SIGNATURE_CONFIG.imgHeight + 25 },
      },
    ],
    [{ content: `Remarks: ${officeFormData?.remarks || ""}`, colSpan: 2 }],
  ];

  // Estimate part1 height: 3 rows × ~20pt each
  const part1EstHeight = 4 * 20;
  // If part1 doesn't fit on current page, start a new page
  if (currentY + config.bordergap + part1EstHeight > availableBottom) {
    doc.addPage();
    currentY = config.topY;
  }

  autoTable(doc, {
    body: part1Body,
    startY: currentY + config.bordergap + 5,
    theme: "grid",
    styles: {
      cellPadding: 3,
      fontSize: config.fontSize,
      halign: "left",
      valign: "middle",
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      font: customFontFamily?.normalFont,
      fontStyle: customFontFamily?.normal,
    },
    margin: {
      top: config.topY + 5,
      left: config.leftMarginOffset + config.margin,
      right: config.margin,
      bottom: config.footerTotalHeight + config.borderMagin,
    },
    columnStyles: sharedColumnStyles,
  });
  currentY = doc.lastAutoTable.finalY;

  // Find users for signatures
  const users = {
    sampleInward: userList?.find(x => x.id == inputStates?.createdBy),
    testContract: userList?.find(x => x.id == inputStates?.createdBy),
    technicalManager: userList?.find(x => x.id == officeFormData?.technicalManager),
  };

  const officeTable = [
    [
      {
        content: "For Office Use Only",
        colSpan: 4,
        styles: { halign: "center", font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold },
      },
    ],
    [
      {
        content: "Review of Test Request",
        colSpan: 4,
      },
    ],
    [
      { content: "Sample Adequacy" },
      {
        content: officeFormData?.sampleAdequacy || "",
        styles: { halign: "center" },
      },
      { content: "Test Within NABL Scope" },
      {
        content: officeFormData?.nablScope || "",
        styles: { halign: "center" },
      },
    ],
    [
      { content: "Test Person Available" },
      {
        content: officeFormData?.testPersonstatus || "",
        styles: { halign: "center" },
      },
      { content: "Source Adequacy" },
      {
        content: officeFormData?.sourceAdequacy || "",
        styles: { halign: "center" },
      },
    ],
    [
      {
        content:
          "Whether the lab has understood/fulfilled the requirements of the Customer - " + (officeFormData?.weatherLab || ""),
        colSpan: 4,
      },
    ],
    [
      { content: "Condition Of Sample" },
      { content: officeFormData?.sampleCondition || "", styles: { halign: "center" } },
      { content: "", colSpan: 2, styles: { halign: "center", valign: "top", minCellHeight: minSignatureHeight } },
    ],
    [
      {
        content: "Instruction from Customers (If Any) - " + officeFormData?.customerRequirement || "",
        colSpan: 4,
      },
    ],
    [
      { content: "", colSpan: 2, styles: { halign: "center", valign: "top", minCellHeight: minSignatureHeight } },
      { content: "", colSpan: 2, styles: { halign: "center", valign: "top", minCellHeight: minSignatureHeight } },
    ],
  ];

  // Estimate part2 height: 8 rows × ~20pt each
  const part2EstHeight = (8 * 20) + minSignatureHeight + 15;
  // If "For Office Use Only" block doesn't fit, start a new page
  if (currentY + config.bordergap + part2EstHeight > availableBottom) {
    doc.addPage();
    currentY = config.topY;
  }

  // Signature configurations: [rowIndex, columnIndex, user, label]
  const signatureConfigs = [
    [5, 2, users.sampleInward, 'Sample Inward By'],
    [7, 0, users.testContract, 'Test Contract Verified By'],
    [7, 2, users.technicalManager, 'Technical Manager'],
  ];

  autoTable(doc, {
    body: officeTable,
    startY: currentY + config.bordergap,
    theme: "grid",
    styles: {
      cellPadding: 3,
      fontSize: config.fontSize,
      halign: "left",
      valign: "middle",
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      font: customFontFamily?.normalFont,
      fontStyle: customFontFamily?.normal,
    },
    margin: {
      top: config.topY + 5,
      left: config.leftMarginOffset + config.margin,
      right: config.margin,
      bottom: config.footerTotalHeight + config.borderMagin,
    },
    columnStyles: sharedColumnStyles,
    didDrawCell: function (data) {
      const sigConfig = signatureConfigs.find(
        ([rowIdx, colIdx]) => data.row.index === rowIdx && data.column.index === colIdx
      );
      if (sigConfig) {
        const [, , user, label] = sigConfig;
        drawSignature(user, data.cell.x, data.cell.y, data.cell.width, label);
      }
    }
  });

  return doc.lastAutoTable.finalY + config.bordergap; // margin bottom
}

// header Table
function drawHeaderTable(doc, jobDetails, inputStates) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const body = [
    [
      { content: "Job No.:", styles: { font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold } },
      { content: jobDetails?.jobNumber || "" },
      { content: "Date:", styles: { font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold } },
      {
        content: inputStates?.inwardDate
          ? moment(inputStates.inwardDate).format("DD-MM-YYYY")
          : "",
      },
    ],
  ];
  autoTable(doc, {
    body,
    startY: config.headerImgHeight + config.margin - 5,
    theme: "grid",
    styles: {
      cellPadding: 4,
      fontSize: config.fontSize,
      halign: "left",
      valign: "middle",
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      font: customFontFamily?.normalFont,
      fontStyle: customFontFamily?.normal,
    },
    margin: { left: config.leftMarginOffset + config.margin - 7, right: config.margin - 7 },
  });

  let currentY = doc.lastAutoTable.finalY;

  // --- Title ---
  doc.setFontSize(config.fontSize + 9);
  doc.setFont("AptosBold", "bold");
  doc.text(
    "Test Request Form",
    pageWidth / 2,
    currentY + config.headerTitleHeight,
    { align: "center" }
  );
  doc.setFont("AptosNormal");

  return currentY + config.headerTitleHeight;
}
// footer table
function drawFooterTable(doc, pageHeight) {
  const body = [
    [
      {
        content: "S & R Geotechniques Pvt Ltd",
        rowSpan: 2,
        styles: { font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold, valign: "middle" },
      },
      { content: "Document Number", styles: { font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold, halign: "center" } },
      { content: "Issue Date", styles: { font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold, halign: "center" } },
      { content: "Issue No.", styles: { font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold, halign: "center" } },
      { content: "Amendment No. & Date", styles: { font: customFontFamily?.boldFont, fontStyle: customFontFamily?.bold, halign: "center" } },
    ],
    [
      { content: "SRGEO/CQF/04/22", styles: { halign: "center" } },
      { content: "02.05.2023", styles: { halign: "center" } },
      { content: "1", styles: { halign: "center" } },
      { content: "01 on 07.08.2023", styles: { halign: "center" } },
    ],
  ];

  autoTable(doc, {
    startY: pageHeight - config.footerImgHeight - config.footerTableHeight,
    body,
    theme: "grid",
    styles: {
      cellPadding: { top: 5, left: 5, bottom: 5, right: 5 },
      fontSize: config.fontSize,
      halign: "left",
      valign: "middle",
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      font: customFontFamily?.normalFont,
      fontStyle: customFontFamily?.normal,
    },
    margin: { left: config.leftMarginOffset + config.margin - 7, right: config.margin - 7, bottom: 0 },
  });
}

function drawCSRFTestTable(doc, testRows, currentY) {
  // Get unique tests by testId
  const seen = new Set();
  const uniqueTests = [];

  testRows.forEach((row) => {
    const testIds = row.testId ? String(row.testId).split(",").map(id => id.trim()) : [""];
    testIds.forEach((testId) => {
      if (seen.has(testId)) return;
      seen.add(testId);
      const testDetail = row.testDetails?.[testId];
      const muValue = testDetail?.muValue || "";
      const testValue = testDetail?.testValue || "";
      const unit = muValue.includes("#")
        ? muValue.split("#")[1]
        : testValue.includes("#")
        ? testValue.split("#")[1]
        : "";

      uniqueTests.push({
        testName: testDetail?.testName || row.testName || "",
        testMethod: testDetail?.testMethod || row.testMethod || "",
        unit,
      });
    });
  });

  const head = [["S.No.", "Test Parameters", "Unit", "Test Method"]];

  const body = uniqueTests.map((test, index) => [
    (index + 1).toString(),
    test.testName,
    test.unit,
    test.testMethod,
  ]);

  const totalPageWidth = doc.internal.pageSize.getWidth() - config.leftMarginOffset - config.margin * 2;

  autoTable(doc, {
    head,
    body,
    startY: currentY + 5,
    theme: "grid",
    styles: {
      cellPadding: { top: 3, left: 5, bottom: 3, right: 5 },
      fontSize: config.fontSize,
      halign: "left",
      valign: "middle",
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      font: customFontFamily?.normalFont,
      fontStyle: customFontFamily?.normal,
    },
    headStyles: {
      fillColor: false,
      font: customFontFamily?.boldFont,
      fontStyle: customFontFamily?.bold,
      halign: "center",
      valign: "middle",
    },
    columnStyles: {
      0: { cellWidth: totalPageWidth * 0.08, halign: "center" },
      1: { cellWidth: totalPageWidth * 0.50 },
      2: { cellWidth: totalPageWidth * 0.12, halign: "center" },
      3: { cellWidth: totalPageWidth * 0.30 },
    },
    margin: {
      top: config.topY + 5,
      left: config.leftMarginOffset + config.margin,
      right: config.margin,
      bottom: config.footerTotalHeight + config.borderMagin,
    },
  });

  return doc.lastAutoTable.finalY;
}

// Main function
export async function generatePDFInward({
  letterHead,
  jobDetails,
  inputStates,
  testRows,
  officeFormData,
  setLoading,
  userList,
  electronicSign,
  signImg,
  isCSRF
}) {
  try {
    setLoading(true);
    const doc = new jsPDF({
      orientation: "l",
      unit: "pt",
      format: "a3",
      compress: true,
    });

    await Promise.all([
      loadAndAddFont(doc, AptosNormal, "Aptos", "AptosNormal", "normal"),
      loadAndAddFont(doc, AptosBold, "Aptos-Bold", "AptosBold", "bold"),
      loadAndAddFont(doc, DejaVuSans, "DejaVuSans", "DejaVuSans", "normal"),
    ]);
    // Set default font
    doc.setFont("AptosNormal");
    doc.setFont("AptosBold");

    const topY = config.topY;
    const bottomMargin = config.borderMagin + config.footerTotalHeight - 2;
    const drawMarginRect = () => {
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);

      const totalWidth = doc.internal.pageSize.getWidth();
      const totalHeight = doc.internal.pageSize.getHeight();

      doc.rect(
        config.leftMarginOffset + config.borderMagin,
        topY,
        totalWidth - config.leftMarginOffset - config.borderMagin * 2,
        totalHeight - topY - bottomMargin
      );
    };

    // Draw Table
    let currentY = drawInwardTable(doc, jobDetails, inputStates);
    if (isCSRF) {
      currentY = drawCSRFTestTable(doc, testRows, currentY);
    } else {
      currentY = drawGroupedTestsTable(doc, testRows, currentY);
    }
    //  doc.addPage();
    //  currentY = topY;
    currentY = drawOfficeUseTable(doc, officeFormData, currentY, userList, electronicSign, signImg, inputStates);

    // Add header/footer if needed
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      if (letterHead) {
        addHeaderFooter(doc, inputStates);
      }
      // Draw outer border
      drawMarginRect();
    }

    // Add page numbers
    const totalPages = doc.getNumberOfPages();
    const pageHeight = doc.internal.pageSize.getHeight();

    for (let page = 1; page <= totalPages; page++) {
      doc.setFontSize(config?.fontSize);
      doc.setPage(page);

      // Draw header footer table on each page
      drawHeaderTable(doc, jobDetails, inputStates);
      drawFooterTable(doc, pageHeight);

      doc.setFontSize(config?.fontSize - 1);
      let content = `Page No : ${String(page).padStart(2, "0")} of ${String(totalPages).padStart(2, "0")}`;
      doc.text(
        content,
        doc.internal.pageSize.getWidth() - config.margin + 5,
        topY - 5,
        { align: "right" }
      );
      doc.setFontSize(config?.fontSize);
    }

    doc.save("test.pdf");
    setLoading(false);
  } catch (error) {
    setLoading(false);
    console.error("Error generating PDF:", error);
  }
}
